import type { SVGProps } from 'react';

const SvgRankingMd = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      d='M12 15C14.7614 15 17 12.4474 17 9.29866V3H7V9.29866C7 12.4474 9.23858 15 12 15Z'
      stroke='currentColor'
      strokeWidth={1.5}
      strokeLinejoin='round'
    />
    <path
      clipRule='evenodd'
      d='M7 10.5V5.5H3C3 8.83335 5 10.5 7 10.5Z'
      stroke='currentColor'
      strokeWidth={1.5}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      clipRule='evenodd'
      d='M17 10.5V5.5H21C21 8.83335 19 10.5 17 10.5Z'
      stroke='currentColor'
      strokeWidth={1.5}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path d='M12 16V18' stroke='currentColor' strokeWidth={1.5} strokeLinecap='round' strokeLinejoin='round' />
    <path d='M7.5 21L9.345 18H14.5212L16.5 21H7.5Z' stroke='currentColor' strokeWidth={1.5} strokeLinejoin='round' />
  </svg>
);
export default SvgRankingMd;
